import React from "react";
import { Spinner } from "react-bootstrap";

function Loading() {
  return <div className="loading-overlay">
    <Spinner animation="border" variant="secondary" />
  </div>;
}

export default Loading;